import { render, staticRenderFns } from "./MonthlyPlan.vue?vue&type=template&id=566136b3&"
import script from "./MonthlyPlan.vue?vue&type=script&lang=ts&"
export * from "./MonthlyPlan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports